/**
 * QuizPage - brand-aware full-page quiz experience.
 *
 * US Citrus Nursery -> CitrusQuiz (citrus tree recommender).
 * Dr. Mani's Magic  -> DrManiQuiz  (three-pillar soil regimen reading).
 *
 * Embedded on Shopify via iframe at /brands/{brandKey}/quiz.
 */
import React from 'react';
import { useBrand } from '../context/BrandContext';
import { CitrusQuiz } from '../components/CitrusQuiz';
import { DrManiQuiz } from '../components/DrManiQuiz';

// API endpoint configuration
// Why this matters: Uses production backend URL, with localhost fallback for development
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://us-citrus-ai-backend.vercel.app';

const QuizPage: React.FC = () => {
  const { brandKey } = useBrand();

  const handleQuizComplete = (data: unknown) => {
    console.log('Quiz completed!', data);
    // In production, this could trigger analytics, redirect, etc.
  };

  if (brandKey === 'drmanismagic') {
    return (
      <DrManiQuiz
        apiEndpoint={`${API_BASE_URL}/api/quiz/submit`}
        onComplete={handleQuizComplete}
      />
    );
  }

  return (
    <CitrusQuiz
      apiEndpoint={`${API_BASE_URL}/api/quiz/submit`}
      onComplete={handleQuizComplete}
    />
  );
};

export default QuizPage;
